// ============================================================================
// Avec — Mapeamento das unidades Feel King ↔ salao_id da Avec
// ============================================================================
// IMPORTANTE: o parâmetro correto da API é "salao" (não "salao_unidade_id"
// como a doc Postman diz). Descoberto empiricamente:
//
//   URL admin: https://admin.avec.beauty/admin/relatorio/0281?salao=59368
//   URL API:   https://api.avec.beauty/reports/0281?salao=59368
// ============================================================================

export const AVEC_UNITS = {
  'moema': {
    feelKingName: 'Moema',
    feelKingUnitId: 'unit-moema',
    avecSalaoId: 73447,
  },
  'vila-olimpia': {
    feelKingName: 'Vila Olímpia',
    feelKingUnitId: 'unit-vila',
    avecSalaoId: 59368,
  },
  'itaim-bibi': {
    feelKingName: 'Itaim Bibi',
    feelKingUnitId: 'unit-itaim',
    avecSalaoId: 77858,
  },
  'oscar-freire': {
    feelKingName: 'Oscar Freire',
    feelKingUnitId: 'unit-oscar',
    avecSalaoId: 100124,
  },
  'jardins': {
    feelKingName: 'Jardins',
    feelKingUnitId: 'unit-jardins',
    avecSalaoId: 105377,
  },
};

// Helper: Feel King unitId → chave Avec
export function getAvecKeyByUnitId(unitId) {
  return Object.entries(AVEC_UNITS)
    .find(([_, u]) => u.feelKingUnitId === unitId)?.[0] || null;
}

// Helper: chave Avec → Feel King unitId
export function getUnitIdByAvecKey(avecKey) {
  return AVEC_UNITS[avecKey]?.feelKingUnitId || null;
}

// Helper: lista só as unidades que já têm ID configurado (prontas para sync)
export function getConfiguredUnits() {
  return Object.entries(AVEC_UNITS)
    .filter(([_, u]) => u.avecSalaoId != null)
    .map(([key, u]) => ({ key, ...u }));
}

// Helper: encontrar unidade pelo salao_id Avec
export function getUnitBySalaoId(salaoId) {
  const id = Number(salaoId);
  return Object.entries(AVEC_UNITS)
    .find(([_, u]) => u.avecSalaoId === id)?.[1] || null;
}

// Helper: lista todas as unidades
export function getAllUnits() {
  return Object.entries(AVEC_UNITS).map(([key, u]) => ({ key, ...u }));
}

// Helper: salao_unidade_id Avec pelo unitId FK
export function getSalaoIdByUnitId(unitId) {
  return Object.values(AVEC_UNITS).find(u => u.feelKingUnitId === unitId)?.avecSalaoId || null;
}
